import { Component } from 'react'

export default class FormModal extends Component {

  render = () => {
    return this.props.children
  }

}